import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';

import { PagesComponent } from './pages.component';
import { CreateUserComponent } from './create-user/create-user.component';
import { UsersComponent } from './users/users.component';
import { EditUserComponent } from './edit-user/edit-user.component';
import { Pf16Component } from './16Pf/pf16/pf16.component';
import { CreatePf16Component } from './16Pf/create-pf16/create-pf16.component';
import { EditPf16Component } from './16Pf/edit-pf16/edit-pf16.component';
import { CreatePf16FactorComponent } from './16Pf/create-pf16-factor/create-pf16-factor.component';
import { EditPf16FactorComponent } from './16Pf/edit-pf16-factor/edit-pf16-factor.component';
import { ClientEvaluatedComponent } from './client-evaluated/client-evaluated.component';
import { CreateEvaluatedComponent } from './create-evaluated/create-evaluated.component';
import { RequestedTestsComponent } from './requested-tests/requested-tests.component';
import { CreateZavicComponent } from './zavic/create-zavic/create-zavic.component';
import { ViewZavicComponent } from './zavic/view-zavic/view-zavic.component';
import { CreateZavicFactorComponent } from './zavic/create-zavic-factor/create-zavic-factor.component';
import { ViewZavicFactorsComponent } from './zavic/view-zavic-factors/view-zavic-factors.component';
import { ZavicComponent } from './zavic/zavic/zavic.component';
import { CreateIpvComponent } from './ipv/create-ipv/create-ipv.component';
import { ViewIpvComponent } from './ipv/view-ipv/view-ipv.component';
import { CreateIpvTypeComponent } from './ipv/create-ipv-type/create-ipv-type.component';
import { ViewIpvTypeComponent } from './ipv/view-ipv-type/view-ipv-type.component';
import { IpvComponent } from './ipv/ipv/ipv.component';
import { ViewAllPortComponent } from './all-port/view-all-port/view-all-port.component';
import { CreateAllPortComponent } from './all-port/create-all-port/create-all-port.component';
import { ViewAllPortFactorComponent } from './all-port/view-all-port-factor/view-all-port-factor.component';
import { AllPortComponent } from './all-port/all-port/all-port.component';
import { CreateAllPortFactorComponent } from './all-port/create-all-port-factor/create-all-port-factor.component';
import { ViewBarsicComponent } from './barsic/view-barsic/view-barsic.component';
import { CreateBarsicComponent } from './barsic/create-barsic/create-barsic.component';
import { CreateBarsicFactorComponent } from './barsic/create-barsic-factor/create-barsic-factor.component';
import { BarsicComponent } from './barsic/barsic/barsic.component';
import { ViewBarsicFactorComponent } from './barsic/view-barsic-factor/view-barsic-factor.component';
import { CreateCleaverFactorComponent } from './cleaver/create-cleaver-factor/create-cleaver-factor.component';
import { EditCleaverFactorComponent } from './cleaver/edit-cleaver-factor/edit-cleaver-factor.component';
import { CreateCleaverComponent } from './cleaver/create-cleaver/create-cleaver.component';
import { EditCleaverComponent } from './cleaver/edit-cleaver/edit-cleaver.component';
import { CleaverComponent } from './cleaver/cleaver/cleaver.component';
import { CreateTermanFactorComponent } from './terman/create-terman-factor/create-terman-factor.component';
import { ViewTermanFactorComponent } from './terman/view-terman-factor/view-terman-factor.component';
import { CreateTermanComponent } from './terman/create-terman/create-terman.component';
import { ViewTermanComponent } from './terman/view-terman/view-terman.component';
import { TermanComponent } from './terman/terman/terman.component';
import { CreateKostikFactorComponent } from './kostik/create-kostik-factor/create-kostik-factor.component';
import { ViewKostikFactorComponent } from './kostik/view-kostik-factor/view-kostik-factor.component';
import { CreateKostikComponent } from './kostik/create-kostik/create-kostik.component';
import { ViewKostikComponent } from './kostik/view-kostik/view-kostik.component';
import { KostikComponent } from './kostik/kostik/kostik.component';
import { PaymentsComponent } from './payments/payments.component';
import { TextsComponent } from './texts/texts.component';
import { Pf16InterpretationComponent } from './16Pf/pf16-interpretation/pf16-interpretation.component';
import { PfTextsComponent } from './16Pf/pf-texts/pf-texts.component';
import { ZavicTextsComponent } from './zavic/zavic-texts/zavic-texts.component';
import { IpvTextsComponent } from './ipv/ipv-texts/ipv-texts.component';
import { AllPortTextsComponent } from './all-port/all-port-texts/all-port-texts.component';
import { BarsicTextsComponent } from './barsic/barsic-texts/barsic-texts.component';
import { CleaverTextsComponent } from './cleaver/cleaver-texts/cleaver-texts.component';
import { TermanTextsComponent } from './terman/terman-texts/terman-texts.component';
import { KostikTextsComponent } from './kostik/kostik-texts/kostik-texts.component';
import { PlansComponent } from './plans/plans.component';
import { EditPlansComponent } from './edit-plans/edit-plans.component';
import { MyAccountComponent } from './my-account/my-account.component';
import { InfoComponent } from './info/info.component';
import { CreateMmpi2FactorComponent } from './mmpi2/create-mmpi2-factor/create-mmpi2-factor.component';
import { Mmpi2InterpretationsComponent } from './mmpi2/mmpi2-interpretations/mmpi2-interpretations.component';
import { Mmpi2QuestionsComponent } from './mmpi2/mmpi2-questions/mmpi2-questions.component';
import { Mmpi2Component } from './mmpi2/mmpi2/mmpi2.component';
import { Mmpi2TextsComponent } from './mmpi2/mmpi2-texts/mmpi2-texts.component';
import { Mmpi2CombinationsComponent } from './mmpi2/mmpi2-combinations/mmpi2-combinations.component';
import { CreateMmpiaFactorComponent } from './mmpia/create-mmpia-factor/create-mmpia-factor.component';
import { MmpiaInterpretationsComponent } from './mmpia/mmpia-interpretations/mmpia-interpretations.component';
import { MmpiaQuestionsComponent } from './mmpia/mmpia-questions/mmpia-questions.component';
import { MmpiaComponent } from './mmpia/mmpia/mmpia.component';
import { MmpiaTextsComponent } from './mmpia/mmpia-texts/mmpia-texts.component';
import { MmpiaCombinationsComponent } from './mmpia/mmpia-combinations/mmpia-combinations.component';
import { CreateScaleComponent } from './mips/create-scale/create-scale.component';
import { MipsInterpretationsComponent } from './mips/mips-interpretations/mips-interpretations.component';
import { MipsQuestionsComponent } from './mips/mips-questions/mips-questions.component';
import { MipsComponent } from './mips/mips/mips.component';
import { MipsTextsComponent } from './mips/mips-texts/mips-texts.component';
import { Bis11Component } from './bis11/bis11/bis11.component';
import { Bis11InterpretationComponent } from './bis11/bis11-interpretation/bis11-interpretation.component';
import { Bis11QuestionsComponent } from './bis11/bis11-questions/bis11-questions.component';
import { Bis11TextsComponent } from './bis11/bis11-texts/bis11-texts.component';
import { ChasideComponent } from './chaside/chaside/chaside.component';
import { ChasideInterpretationsComponent } from './chaside/chaside-interpretations/chaside-interpretations.component';
import { ChasideQuestionsComponent } from './chaside/chaside-questions/chaside-questions.component';
import { ChasideTextsComponent } from './chaside/chaside-texts/chaside-texts.component';
import { DominoComponent } from './domino/domino/domino.component';
import { DominoTextsComponent } from './domino/domino-texts/domino-texts.component';
import { CreateFactorsComponent } from './domino/create-factors/create-factors.component';
import { FormsComponent } from './forms/forms.component';
import { CustomTestsComponent } from './custom-tests/custom-tests.component';
import { CreateCustomTestsComponent } from './create-custom-tests/create-custom-tests.component';
import { TestGroupsComponent } from './test-groups/test-groups.component';
import { CreateTestGroupComponent } from './create-test-group/create-test-group.component';
import { CustomFormComponent } from './custom-form/custom-form.component';
import { CustomTestReportComponent } from './custom-test-report/custom-test-report.component';
import { GroupsInfoComponent } from './groups-info/groups-info.component';
import { CustomTestHistoryComponent } from './custom-test-history/custom-test-history.component';
import { SubaccountsComponent } from './subaccounts/subaccounts.component';
import { HumanFactorTextsComponent } from './cleaver/human-factor-texts/human-factor-texts.component';
import { EmailTextsComponent } from './email-texts/email-texts.component';
import { TestInfoComponent } from './test-info/test-info.component';


const routes: Routes = [

  {path: 'dashboard', component:PagesComponent,
    children: [
      {path: '', component: UsersComponent},
      {path: 'createUser', component: CreateUserComponent},
      {path: 'users', component: UsersComponent},
      {path: 'editUser', component: EditUserComponent},
      {path: 'pf16', component: Pf16Component},
      {path: 'createPf16', component: CreatePf16Component},
      {path: 'editPf16', component: EditPf16Component},
      {path: 'createPf16Factor', component: CreatePf16FactorComponent},
      {path: 'pf16Factor', component: EditPf16FactorComponent},
      {path: 'clientEvaluated', component: ClientEvaluatedComponent},
      {path: 'createEvaluated', component: CreateEvaluatedComponent},
      {path: 'forms', component: FormsComponent},
      {path: 'requestedTests', component: RequestedTestsComponent},
      {path: 'createZavic', component: CreateZavicComponent},
      {path: 'editZavic', component: ViewZavicComponent},
      {path: 'createZavicFactor', component: CreateZavicFactorComponent},
      {path: 'viewZavicFactor', component: ViewZavicFactorsComponent},
      {path: 'zavic', component: ZavicComponent},
      {path: 'createIpv', component: CreateIpvComponent},
      {path: 'editIpv', component: ViewIpvComponent},
      {path: 'createIpvFactor', component: CreateIpvTypeComponent},
      {path: 'viewIpvFactor', component: ViewIpvTypeComponent},
      {path: 'ipv', component: IpvComponent},
      {path: 'viewAllPortFactor', component: ViewAllPortFactorComponent},
      {path: 'createAllPort', component: CreateAllPortComponent},
      {path: 'createAllPortFactor', component: CreateAllPortFactorComponent},
      {path: 'viewAllPort', component: ViewAllPortComponent},
      {path: 'allPort', component: AllPortComponent},
      {path: 'createBarsicFactor', component: CreateBarsicFactorComponent},
      {path: 'viewBarsicFactor', component: ViewBarsicFactorComponent},
      {path: 'createBarsic', component: CreateBarsicComponent},
      {path: 'viewBarsic', component: ViewBarsicComponent},
      {path: 'barsic', component: BarsicComponent},
      {path: 'createCleaverFactor', component: CreateCleaverFactorComponent},
      {path: 'viewCleaverFactor', component: EditCleaverFactorComponent},
      {path: 'createCleaver', component: CreateCleaverComponent},
      {path: 'viewCleaver', component: EditCleaverComponent},
      {path: 'cleaver', component: CleaverComponent},
      {path: 'humanFactorTexts', component: HumanFactorTextsComponent},
      {path: 'createTermanFactor', component: CreateTermanFactorComponent},
      {path: 'viewTermanFactor', component: ViewTermanFactorComponent},
      {path: 'createTerman', component: CreateTermanComponent},
      {path: 'viewTerman', component: ViewTermanComponent},
      {path: 'terman', component: TermanComponent},
      {path: 'createKostikFactor', component: CreateKostikFactorComponent},
      {path: 'viewKostikFactor', component: ViewKostikFactorComponent},
      {path: 'createKostik', component: CreateKostikComponent},
      {path: 'viewKostik', component: ViewKostikComponent},
      {path: 'kostik', component: KostikComponent},
      {path: 'payments', component: PaymentsComponent},
      {path: 'texts', component: TextsComponent},
      {path: 'emailTexts', component: EmailTextsComponent},
      {path: 'testInfo', component: TestInfoComponent},
      {path: '16PfInterpretation', component: Pf16InterpretationComponent},
      {path: 'pfTexts', component: PfTextsComponent},
      {path: 'zavicTexts', component: ZavicTextsComponent},
      {path: 'ipvTexts', component: IpvTextsComponent},
      {path: 'allPortTexts', component: AllPortTextsComponent},
      {path: 'barsicTexts', component: BarsicTextsComponent},
      {path: 'cleaverTexts', component: CleaverTextsComponent},
      {path: 'termanTexts', component: TermanTextsComponent},
      {path: 'kostikTexts', component: KostikTextsComponent},
      {path: 'plans', component: PlansComponent},
      {path: 'editPlans', component: EditPlansComponent},
      {path: 'myAccount', component: MyAccountComponent},
      {path: 'info', component: InfoComponent},
      {path: 'createMmpi2Factor', component:CreateMmpi2FactorComponent},
      {path: 'mmpi2Interpretations', component:Mmpi2InterpretationsComponent},
      {path: 'mmpi2Questions', component:Mmpi2QuestionsComponent},
      {path: 'mmpi2', component:Mmpi2Component},
      {path: 'mmpi2Texts', component:Mmpi2TextsComponent},
      {path: 'mmpi2Combinations', component:Mmpi2CombinationsComponent},
      {path: 'createMmpiaFactor', component:CreateMmpiaFactorComponent},
      {path: 'mmpiaInterpretations', component:MmpiaInterpretationsComponent},
      {path: 'mmpiaQuestions', component:MmpiaQuestionsComponent},
      {path: 'mmpia', component:MmpiaComponent},
      {path: 'mmpiaTexts', component:MmpiaTextsComponent},
      {path: 'mmpiaCombinations', component:MmpiaCombinationsComponent},
      {path: 'mipsScales', component:CreateScaleComponent},
      {path: 'mipsInterpretations', component:MipsInterpretationsComponent},
      {path: 'mipsQuestions', component:MipsQuestionsComponent},
      {path: 'mips', component:MipsComponent},
      {path: 'mipsTexts', component:MipsTextsComponent},
      {path: 'bis11', component:Bis11Component},
      {path: 'bis11Interpretations', component:Bis11InterpretationComponent},
      {path: 'bis11Questions', component:Bis11QuestionsComponent},
      {path: 'bis11Texts', component:Bis11TextsComponent},
      {path: 'chaside', component:ChasideComponent},
      {path: 'chasideInterpretations', component:ChasideInterpretationsComponent},
      {path: 'chasideQuestions', component:ChasideQuestionsComponent},
      {path: 'chasideTexts', component:ChasideTextsComponent},
      {path: 'custom-tests', component:CustomTestsComponent},
      {path: 'create-custom-test', component:CreateCustomTestsComponent},
      {path: 'test-groups', component:TestGroupsComponent},
      {path: 'create-test-group', component:CreateTestGroupComponent},
      {path: 'custom-test/:formId', component:CustomFormComponent},
      {path: 'custom-test-history', component:CustomTestHistoryComponent},

      {path: 'domino', component:DominoComponent},
      {path: 'dominoTexts', component: DominoTextsComponent},
      {path: 'dominoInterpretations', component: CreateFactorsComponent},
      {path: 'custom-test-report/:testId', component:CustomTestReportComponent},
      {path: 'groups-info', component: GroupsInfoComponent},
      {path: 'accounts/:userId', component: SubaccountsComponent}

    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesRoutingModule { }
